<template>
  <v-page-content>
    <v-all-news editMode></v-all-news>
  </v-page-content>
</template>

<script>
const VAllNews = () => import('@/components/content/news/AllNews.vue')

export default {
  name: 'EditNews',
  components: {
    VAllNews
  }
}
</script>

<style scoped>

</style>
